import React from 'react';

/**
 * ProductRating - Pure component for displaying product ratings
 * Follows React Rules: Pure, idempotent, immutable props
 * 
 * @param {number} rating - Rating value from 0 to 5
 * @param {boolean} showReviewLink - Whether to show review links
 */
const ProductRating = ({ rating = 0, showReviewLink = false }) => {
  // Ensure rating is between 0 and 5
  const normalizedRating = Math.max(0, Math.min(5, Math.round(rating)));
  const fullStars = normalizedRating;
  const emptyStars = 5 - normalizedRating;

  return (
    <div className="rating-box">
      <ul className="rating">
        {Array.from({ length: fullStars }, (_, i) => (
          <li key={`full-${i}`}>
            <i className="fa fa-star-o"></i>
          </li>
        ))}
        {Array.from({ length: emptyStars }, (_, i) => (
          <li key={`empty-${i}`} className="no-star">
            <i className="fa fa-star-o"></i>
          </li>
        ))}
        {showReviewLink && (
          <>
            <li className="review-item">
              <a href="#reviews">Read Review</a>
            </li>
            <li className="review-item">
              <a href="#reviews">Write Review</a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default ProductRating;

